import React from 'react';
import { Page, Text, View, Document, StyleSheet } from '@react-pdf/renderer';
import moment from "moment";

// Define styles for your document
const styles = StyleSheet.create({
    page: { padding: 30 },
    table: { display: 'table', width: 'auto', borderStyle: 'solid', borderWidth: 1, borderColor: '#bfbfbf', marginBottom: 10 },
    tableRow: { flexDirection: 'row' },
    tableHeader: { backgroundColor: '#f0f0f0' },
    tableCol: { width: '33.33%', borderStyle: 'solid', borderWidth: 1, borderColor: '#bfbfbf', padding: 5, fontSize: 10, textAlign: 'center' },
    tableCell: { margin: 'auto', marginTop: 5, fontSize: 8 },
    title: { fontSize: 18, textAlign: 'center', marginBottom: 20 },
});

const HistoryPDF = ({ data }) => (
    <Document>
        <Page size="A4" style={styles.page}>
            <View>
                <Text style={styles.title}>History Report</Text>
                <View style={styles.table}>
                    {/* Table Header */}
                    <View style={[styles.tableRow, styles.tableHeader]}>
                        <Text style={styles.tableCol}>User Name</Text>
                        <Text style={styles.tableCol}>Email</Text>
                        <Text style={styles.tableCol}>Message</Text>
                        <Text style={styles.tableCol}>Created At</Text>

                    </View>
                    {data.map((item, index) => (
                        <View style={styles.tableRow} key={index}>
                            <Text style={styles.tableCol}>
                                {/* {item.firstName} */}
                                {item.firstName.length <= 20 ?
                                    item.firstName :
                                    item.firstName.slice(0, -14) + " " + item.firstName.slice(-14)
                                }
                            </Text>
                            <Text style={styles.tableCol}>
                                {/* {item.email} */}
                                {item.email.length <= 15 ?
                                    item.email :
                                    item.email.slice(0, -8) + " " + item.email.slice(-8)
                                }
                            </Text>
                            <Text style={styles.tableCol}>
                                {/* {item.message} */}
                                {item.message.length <= 20 ?
                                    item.message :
                                    item.message.slice(0, -10) + " " + item.message.slice(-10)
                                }
                            </Text>
                            <Text style={styles.tableCol}>
                                {moment(item.createdAt).format("lll")}
                            </Text>
                        </View>
                    ))}
                </View>
            </View>
        </Page>
    </Document>
);

export default HistoryPDF;